import React from 'react';
import {
    TEMPORARY_CLOSURE_MESSAGE,
    TEMPORARY_CLOSURE_TITLE
} from '../shared/temporaryClosure';
import './TemporaryClosureModal.css';

interface TemporaryClosureModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const TemporaryClosureModal: React.FC<TemporaryClosureModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="temporary-closure-overlay" onClick={handleBackdropClick}>
            <section
                className="temporary-closure-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="temporary-closure-title"
            >
                <button
                    className="temporary-closure-close"
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                >
                    x
                </button>

                <div className="temporary-closure-icon" aria-hidden="true">
                    <span className="temporary-closure-pause-bar" />
                    <span className="temporary-closure-pause-bar" />
                </div>

                <h2 id="temporary-closure-title" className="temporary-closure-title">
                    {TEMPORARY_CLOSURE_TITLE}
                </h2>

                <div className="temporary-closure-copy">
                    {TEMPORARY_CLOSURE_MESSAGE.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                    ))}
                </div>

                <button className="temporary-closure-button" type="button" onClick={onClose}>
                    Close
                </button>
            </section>
        </div>
    );
};

export default TemporaryClosureModal;
